import CashierActionType from 'actions/cashier/cashierActionType';

const initialState = {
  cashierGeneralSettings: {},
  cashierBrandSettings: {},
};

const cashierReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case CashierActionType.SAVE_CASHIER_GENERAL_SETTINGS:
    return {
      ...state,
      cashierGeneralSettings: payload.data,
    };
  case CashierActionType.RESET_CASHIER_GENERAL_SETTINGS:
    return {
      ...state,
      cashierGeneralSettings: {},
    };
  case CashierActionType.SAVE_CASHIER_BRAND_SETTINGS:
    return {
      ...state,
      cashierBrandSettings: payload.data,
    };
  case CashierActionType.RESET_CASHIER_BRAND_SETTINGS:
    return {
      ...state,
      cashierBrandSettings: {},
    };
  default:
    return state;
  }
};

export default cashierReducer;
